import { SET_FIRST_NAME } from 'actions';

export function setFirstName(firstName: string) {
  return { firstName, type: SET_FIRST_NAME };
}
